var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "5,26.3 5,24.3 35,24.3 35,26.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,19.2c0-1.6,1.5-2.9,3.2-2.9c1.8,0,3.2,1.3,3.2,2.9c0,1.6-1.5,2.9-3.2,2.9C7.8,22.1,6.3,20.8,6.3,19.2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.1,
    y1: 19.9,
    x2: 31.6,
    y2: 19.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,15.8l1.5,0l8.3,3.2v3.8H14.4c-0.6-0.3-1-0.9-1-1.5v-4.1c0-0.8,0.5-1.4,1.3-1.7l7.2-1.9V15.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInactive);
export default __webpack_public_path__ + "static/media/client-inactive.ad6e3ba2480ab033dd9c45eaddbe806f.svg";
export { ForwardRef as ReactComponent };